import * as S from "../../Style/Page/Hat.style.js";
import { Link } from "react-router-dom";
import { ReactComponent as Home } from "../../assets/icon/home.svg";
import Arrow from "../../assets/icon/lnb_arrow.png";
import PageTitle from "../../Component/PageTitle.js";

import HatPageTopLine from "../../Component/HatPageTopLine.js";
const History = () => {
  return (
    <S.Page className={localStorage.getItem("language")}>
      <HatPageTopLine name={"모자사업"} ename={"YoungAn Hat"} />
      <section className="section" id="hat-introduce-section">
        <S.PageNavidation>
          <Link to="/" className="logo">
            <Home />
          </Link>
          <S.Nav height={"364px"}>
            <S.NavItem>
              <Link to="/HatBusiness/Introduce">
                <div className="kor">모자사업</div>
                <div className="eng">Hat Business</div>
              </Link>
            </S.NavItem>

            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/ForkLiftBusiness/Introduce">
                  <div className="kor">지게차사업</div>
                  <div className="eng">ForkLift Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/CarBusiness/introduce">
                  <div className="kor">자동차사업</div>
                  <div className="eng">Car Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/BusBusiness/OverseasBus">
                  <div className="kor">버스사업</div>
                  <div className="eng">Bus Business</div>
                </Link>
              </S.NavItem>

              <S.NavItem className="list-inner-item">
                <Link to="/GeneralBusiness/introduce">
                  <div className="kor">일반사업</div>
                  <div className="eng">General Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/SocialBusiness/SocialService">
                  <div className="kor">사회사업</div>
                  <div className="eng">Social Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/WBH/WBH">WBH</Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>

          <S.Nav height={"260px"}>
            <S.NavItem className="list-inner-item">
              <Link to="/HatBusiness/History">
                <div className="kor">주요사업이력</div>
                <div className="eng">Major business history</div>
              </Link>
            </S.NavItem>
            <div className="open-list">
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/Introduce">
                  <div className="kor">모자사업</div>
                  <div className="eng">Hat Business</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/KoreaCompany">
                  <div className="kor">영안모자 한국본사</div>
                  <div className="eng">Korean Headquarters</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/ProductionCorporation">
                  <div className="kor">직경영사업장</div>
                  <div className="eng">Direct Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/SalesCorporation">
                  <div className="kor">위탁경영사업장</div>
                  <div className="eng">Indirect Management Affiliates</div>
                </Link>
              </S.NavItem>
              <S.NavItem className="list-inner-item">
                <Link to="/HatBusiness/History">
                  <div className="kor">주요사업이력</div>
                  <div className="eng">Major business history</div>
                </Link>
              </S.NavItem>
            </div>
            <img src={Arrow} className="down-arrow" alt="" />
          </S.Nav>
        </S.PageNavidation>

        <div className="wrap">
          <div className="inner">
            <PageTitle
              titleko={"모자사업 / 주요사업이력"}
              titleeng={"Hat business / Major business history"}
            />
            <S.HistoryTable class="history-table">
              <div class="history-table-head">
                <div class="history-table-ceil-small">
                  <div className="kor">구분</div>
                  <div className="eng">Year</div>
                </div>
                <div class="history-table-ceil-big">
                  <div className="kor">주요 사업내용</div>
                  <div className="eng">Major business history</div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1959.2.5</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">영안모자점 창업(청계천, 소매업)</div>
                    <div className="eng">
                      Founded YoungAn Hat (in the Cheonggye stream, Retail
                      business)
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1966</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      모자 첫 수출(일본 / 제국모자, 중앙모자에 임가공 수출)
                    </div>
                    <div className="eng">
                      First export of hats to Japan (toll processing export)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1967.10</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      영안모자 북가좌동 제1공장 준공 / 인력 100명 (가동
                      1967~1989)
                    </div>
                    <div className="eng">
                      Constructed 1st factory in Bukgajwa-dong / 100 employees
                      (Operation : 1967~1989)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1969. 2</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">영안모자상사로 상호변경</div>
                    <div className="eng">
                      Changed the company name to YoungAn Hat Company
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1975</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      미국 판매법인 Ed's west 설립(캘리포니아주) / 1981년 매각
                    </div>
                    <div className="eng">
                      Established sales corporation, Ed's west in California,
                      USA (1975~1981)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1984. 2. 1</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">영안모자(주) 설립</div>
                    <div className="eng">Established YoungAn Hat Co.,Ltd.</div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1985. 6</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      YoungAn Hat S.A(코스타리카 생산법인) 설립 / 인력 210명
                      (가동 1985~1996)
                    </div>
                    <div className="eng">
                      Established YoungAn Hat S.A(Manufacturing corporation) in
                      Costa Rica / 210 employees
                      <br />
                      (Operation : 1985~1996)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1986. 7</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      캐나다 판매법인 AJM Int’l 설립(몬트리올) (50% 합자)
                    </div>
                    <div className="eng">
                      50% J/V in sales corporation, AJM Int’l in Canada (50%
                      J/V)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1987. 12</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      YoungAn Lanka(Pvt) Ltd.(스리랑카 생산법인) 설립 및
                      공장가동(1988.7~ )
                    </div>
                    <div className="eng">
                      Established manufacturing corporation, YoungAn Lanka(Pvt)
                      Ltd. in Sri Lanka and
                      <br />
                      started factory operation(Jul.1988~ )
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1989. 12</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      미국 판매법인 Outdoor Cap Co., Inc. 합자투자(50%)
                      (알칸소주) / 오클라호마 공장 준공
                    </div>
                    <div className="eng">
                      50% J/V in sales corporation, Outdoor Cap Co.,Inc. in
                      Arkansas, USA
                      <br />/ Constructed the factory in Oklahoma
                    </div>
                  </div>

                  <div class="line"></div>
                  <div class="ceil-kor">
                    <div className="kor">
                      YoungAn Hat(BD) Ltd.(방글라데시 생산법인) 설립 /
                      방글라데시 제1공장 가동(1990.7~ )
                    </div>
                    <div className="eng">
                      Established manufacturing corporation, YoungAn Hat(BD)
                      Ltd. in Bangladesh
                      <br />/ Started 1st factory operation(Jul.1990~ )
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1990. 2</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      Hatfash Ltd.(홍콩 생산법인) 설립 (50% 합자) / 1996년
                      중국공장(스트로햇 생산) 사업중단 및 1999년 지분 100% 인수
                    </div>
                    <div className="eng">
                      50% J/V in manufacturing corporation, Hatfash Ltd. in
                      HongKong
                      <br />
                      / Suspended the operation of China factory(production of
                      Straw hat) in 1996 and
                      <br />
                      acquired 100% equity of shares in 1999
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1993. 2</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      미국 판매법인 Dorfman-Pacific Co., Inc. 합자투자(50%)
                      (캘리포니아주)
                    </div>
                    <div className="eng">
                      50% J/V in sales corporation, Dorfman-Pacific Co., Inc. in
                      California, USA
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">1997. 4</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      (주)스포츠아이콘 설립 (1997.4 ~ 2002.12)
                    </div>
                    <div className="eng">
                      Established Sports Icon Co.,Ltd. (Apr.1997~Dec.2002)
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2002. 12</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      (주)스포츠아이콘 -> (주)영안양행 으로 상호변경
                    </div>
                    <div className="eng">
                      Changed name / Sports Icon Co.,Ltd. -> YoungAn
                      International Co.,Ltd.
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2003. 6</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      YoungAn Int'l Lanka(Pvt) Ltd.(스리랑카 생산법인) 설립 /
                      제3공장 인수후 모자생산 시작
                    </div>
                    <div className="eng">
                      Established manufacturing corporation, YoungAn Int'l
                      Lanka(Pvt) Ltd. in Sri Lanka
                      <br />/ Started production after the acquisition of 3rd
                      factory
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2003. 10</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      생산법인 Shangahai Gausha Accessory Co., Ltd.(SGA, 중국
                      상해) 돌프만이 지분 인수(50%)
                    </div>
                    <div className="eng">
                      Dorfman Pacific acquired 50% equity of Shangahai Gausha
                      Accessory Co., Ltd.
                      <br />
                      (manufacturing corporation) in Shanghai, China
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2004. 7</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      생산법인 Milano Hat Co.,Inc.(미국 텍사스주) 돌프만이 지분
                      인수(100%)
                    </div>
                    <div className="eng">
                      Dorfman Pacific acquired 100% equity of manufacturing
                      corporation, Milano in Texas, USA
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2005. 11</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      YA-AJM Vina Co.,Ltd.(베트남 생산법인) 설립 (합자 YA 75% /
                      AJM 25%) / 공장가동(2006.6~ )
                    </div>
                    <div className="eng">
                      Established manufacturing corporation, YA-AJM Vina
                      Co.,Ltd. in Haiduong, Vietnam
                      <br />
                      (J/V : YA 75% / AJM 25%) / Started operation(Jun.2006~ )
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2009. 12</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      YoungAn Int'l(BD) Ltd.(방글라데시 생산법인) 설립 /
                      방글라데시 제2공장 가동(2011.5~ )
                    </div>
                    <div className="eng">
                      Established manufacturing corporation, YoungAn Int'l(BD)
                      Ltd. In Bangladesh
                      <br />/ Started 2nd factory operation(May.2011~ )
                    </div>
                  </div>
                </div>
              </div>
              <div class="history-table-line">
                <div class="history-table-ceil-small">2011. 9</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      생산법인 FERGAR S.A de C.V(멕시코) 돌프만이 지분 인수(50%)
                    </div>
                    <div className="eng">
                      Dorfman Pacific acquired 50% of equity of manufacturing
                      corporation, Fergar Hat in Mexico
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2015. 11</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      생산법인 Junk Brands Company LLC(미국 알칸소주) 아웃도아가
                      지분 인수(100%)
                    </div>
                    <div className="eng">
                      Outdoor Cap Co.,Inc. acquired 100% of equity of
                      manufacturing corporation,
                      <br />
                      Junk Brands in Arkansas, USA
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2017. 7</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      홍콩 생산법인 Sunny Hats Ltd. 지분 인수(50%)
                    </div>
                    <div className="eng">
                      Acquired 50% of equity of manufacturing corporation, Sunny
                      Hats Ltd. In HongKong
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2018. 5</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      싱가폴 판매법인 YoungAn Hat Singapore Pte Ltd. 설립
                    </div>
                    <div className="eng">
                      Established sales corporation, YoungAn Hat Singapore Pte
                      Ltd. in Singapore
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2018. 7</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      호주 판매법인 Greenwich Hat 재설립(합자 YA 50% /
                      하몬드가족 50%)
                    </div>
                    <div className="eng">
                      Re-established sales corporation Greenwich Hat in
                      Australia
                      <br />
                      (J/V : YA 50% / Hammond family 50%)
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line last-line">
                <div class="history-table-ceil-small">2019</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      판매법인 Legendary Headwear LLC(미국 캘리포니아주)
                      아웃도아가 지분 인수(100%) / 아웃도아와 합병(2023년)
                    </div>
                    <div className="eng">
                      Outdoor Cap Co.,Inc acquired 100% of equity of sales
                      corporation,
                      <br />
                      Legendary Headwear LLC in California, USA / Merged with
                      Outdoor Cap Co.,Inc.(2023)
                    </div>
                  </div>
                </div>
              </div>
            </S.HistoryTable>

            <PageTitle
              titleko={"의류사업 / 주요사업이력"}
              titleeng={"Clothing Business / Major business history"}
            />
            <S.HistoryTable class="history-table">
              <div class="history-table-head">
                <div class="history-table-ceil-small">
                  <div className="kor">구분</div>
                  <div className="eng">Year</div>
                </div>
                <div class="history-table-ceil-big">
                  <div className="kor">주요 사업내용</div>
                  <div className="eng">Major business history</div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">1997. 4</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      (주)스포츠아이콘 설립 (1997.4 ~ 2002.12)
                    </div>
                    <div className="eng">
                      Established Sports Icon Co.,Ltd. (Apr.1997~Dec.2002)
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line">
                <div class="history-table-ceil-small">2005. 6</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      의류 생산법인 Verecco Guatemala S.A. 인수(과테말라)
                      (2005.6. ~ 2006.12)
                    </div>
                    <div className="eng">
                      Acquired apparel manufacturing corporation, Verecco
                      Guatemala S.A. in Guatemala
                      <br />
                      (Jun.2005~Dec.2006)
                    </div>
                  </div>
                </div>
              </div>

              <div class="history-table-line last-line">
                <div class="history-table-ceil-small">2020. 8</div>
                <div class="history-table-ceil-big">
                  <div class="ceil-kor">
                    <div className="kor">
                      의류 생산법인 PT.NAMNAM Fashion Industries
                      인수(인도네시아) / (주)영안양행이 지분 인수(100%)
                    </div>
                    <div className="eng">
                      YoungAn International Co.,Ltd. acquired 100% of equity of
                      apparel manufacturing
                      <br />
                      corporation, PT.NAMNAM Fashion Industries in Indonesia
                    </div>
                  </div>
                </div>
              </div>
            </S.HistoryTable>
          </div>
        </div>
      </section>
    </S.Page>
  );
};

export default History;
